import React, { useEffect, useState } from 'react';
import { ProgressBar, IntentProps as IIntentProps } from '@blueprintjs/core';

interface LoadingProgressProps {
  intent?: IIntentProps['intent'];
  value?: number;
  step?: number;
  large?: boolean;
}

const DEFAULT_STEP = 0.5;

const LoadingProgress: React.FC<LoadingProgressProps> = ({
  intent,
  value: _value,
  step: _step,
  large
}) => {
  const originalStep = _step || DEFAULT_STEP;
  const [step, setStep] = useState(originalStep);
  const [value, setValue] = useState(_value || 0);
  const [faker, setFaker] = useState<ReturnType<typeof setInterval>>(null);
  useEffect(() => {
    let isCanceled = false;
    setFaker(
      setInterval(() => {
        if (isCanceled) {
          return;
        }
        const _progress = value + step;
        setValue(_progress);
        const progress =
          Math.round((Math.atan(_progress) / (Math.PI / 2)) * 100 * 1000) /
          1000;
        if (progress >= 100) {
          clearInterval(faker);
        } else if (progress >= 50) {
          if (step >= originalStep) {
            setStep(originalStep / 2);
          }
        } else if (progress >= 70) {
          if (step >= originalStep / 2) {
            setStep(originalStep / 5);
          }
        }
      }, 100)
    );
    return () => {
      isCanceled = true;
      clearInterval(faker);
    };
  }, [value]);
  const progress =
    Math.round((Math.atan(value + step) / (Math.PI / 2)) * 100 * 1000) / 1000;
  return (
    <div>
      <ProgressBar
        className={large ? 'progressbar-large' : null}
        intent={intent}
        animate
        value={progress / 100}
      />
    </div>
  );
};

export default LoadingProgress;

interface LoadingBlockProps {
  slowLoadMessage?: string;
  slowLoadDelayMs?: number;
}

export const LoadingBlock: React.FC<LoadingBlockProps> = ({
  slowLoadMessage,
  slowLoadDelayMs = 10000
}) => {
  const [showSlowMessage, setShowSlowMessage] = useState(false);

  useEffect(() => {
    setShowSlowMessage(false);
    if (!slowLoadMessage) {
      return;
    }
    const timer = setTimeout(() => {
      setShowSlowMessage(true);
    }, slowLoadDelayMs);
    return () => clearTimeout(timer);
  }, [slowLoadMessage, slowLoadDelayMs]);

  return (
    <div
      style={{
        padding: '80px 0'
      }}
    >
      <LoadingProgress intent="primary" large />
      {showSlowMessage && slowLoadMessage && (
        <p
          style={{
            textAlign: 'center',
            marginTop: '16px',
            color: '#5c7080'
          }}
        >
          {slowLoadMessage}
        </p>
      )}
    </div>
  );
};
